import { render, staticRenderFns } from "./Pruefungenliste.vue?vue&type=template&id=6005e3bb&scoped=true"
import script from "./Pruefungenliste.vue?vue&type=script&lang=js"
export * from "./Pruefungenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005e3bb",
  null
  
)

export default component.exports